import { all, fork } from 'redux-saga/effects';

import errorSaga from './sagas/errorSaga';

export function* rootSaga() {
  yield all([fork(errorSaga)]);
}
